import React, { useEffect, useState } from 'react';
import { useResizeListener } from 'primereact/hooks';
import LoadingContent from 'components/LoadingContent';
import Template from 'components/Template';
import Footer from 'components/Footer';
import { CollectionsProvider } from 'Providers/CollectionsProviders';
import { useLocation } from 'react-router-dom';
import ShoppingCartBadge from './components/ShoppingCartBadge';
import isEmpty from 'lodash/isEmpty';
import { getCategories, getSubCategories } from './utils';

const TemplateScreen = ({ Screen }) => {
  const { pathname } = useLocation();

  const [eventData, setEventData] = useState({
    width: 0,
    height: 0,
  });
  const [bindWindowResizeListener, unbindWindowResizeListener] =
    useResizeListener({
      listener: (event) => {
        setEventData({
          width: event.currentTarget.innerWidth,
          height: event.currentTarget.innerHeight,
        });
      },
    });
  const [subCategories, setSubCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoriesObj, setCategoriesObj] = useState([]);

  useEffect(() => {
    getCategories(setCategories, setCategoriesObj);
    getSubCategories(setSubCategories);
  }, []);

  useEffect(() => {
    setEventData({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }, []);

  useEffect(() => {
    bindWindowResizeListener();
    return () => {
      unbindWindowResizeListener();
    };
  }, [bindWindowResizeListener, unbindWindowResizeListener]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (eventData.width === 0 || isEmpty(subCategories) || isEmpty(categories)) {
    return <LoadingContent minHeight={window.innerHeight} />;
  }

  return (
    <div className="App">
      <CollectionsProvider>
        <Template
          categories={categoriesObj}
          eventData={eventData}
          subCategories={subCategories}
        />
        {Screen(eventData, categories, subCategories, categoriesObj)}
        <ShoppingCartBadge eventData={eventData} />
        <Footer eventData={eventData} />
      </CollectionsProvider>
    </div>
  );
};

export default TemplateScreen;
